import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_3 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Tên đăng nhập", -1)
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Mật khẩu(tối thiểu 6 ký tự)", -1)
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Họ và tên", -1)
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Chọn quyền hạn", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Danh sách tài khoản" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_DataTable, {
            loading: $setup.isLoading,
            value: $setup.list,
            paginator: true,
            stripedRows: "",
            rows: 10,
            rowsPerPageOptions: [10,25,50],
            rowHover: true,
            filters: $setup.filters,
            "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            globalFilterFields: ['fullname','username'],
            currentPageReportTemplate: "Có tổng số {totalRecords} tài khoản",
            columnResizeMode: "fit | expand"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-filter-slash",
                  label: "Xoá",
                  class: "p-button-outlined",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter())),
                  style: {"width":"6em"}
                }),
                _createElementVNode("span", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_InputText, {
                    modelValue: $setup.filters['global'].value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                    placeholder: "Tìm theo tên hoặc tài khoản"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "fullname",
                header: "Họ và tên",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "username",
                header: "Tài khoản",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "permission",
                header: "Quyền hạn",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                header: "Chỉnh sửa",
                style: {"width":"200px"}
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    type: "button",
                    label: "Chỉnh sửa",
                    icon: "pi pi-pencil",
                    onClick: ($event: any) => ($setup.loadDataUser(slotProps.data.id))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "value", "filters"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Dialog, {
              visible: $setup.updateReg,
              "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (($setup.updateReg) = $event)),
              style: { width: '70vw'},
              breakpoints: { '1500px': '50vw', '1150px': '60vw' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Panel, { header: "Cập nhật tài khoản" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createVNode(_component_InputText, {
                          id: "username",
                          type: "text",
                          modelValue: $setup.userUpdate.username,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userUpdate.username) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_Password, {
                          id: "password",
                          modelValue: $setup.userUpdate.password,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userUpdate.password) = $event)),
                          toggleMask: "",
                          feedback: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_InputText, {
                          id: "fullname",
                          type: "text",
                          modelValue: $setup.userUpdate.fullname,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.userUpdate.fullname) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_Dropdown, {
                          id: "permission",
                          modelValue: $setup.userUpdate.permission,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.userUpdate.permission) = $event)),
                          options: $setup.userPermission,
                          optionLabel: "label",
                          optionValue: "value",
                          placeholder: "Vui lòng chọn quyền hạn của tài khoản ..."
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]),
                    _createVNode(_component_Button, {
                      label: "Cập nhật",
                      icon: "pi pi-sync",
                      iconPos: "left",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.doUpdate())),
                      style: {"width":"15em","margin-right":"2vw","margin-bottom":"20px"}
                    }),
                    _createVNode(_component_Button, {
                      label: "Xoá",
                      class: "p-button-danger",
                      icon: "pi pi-user-minus",
                      iconPos: "left",
                      style: {"width":"15em","margin-bottom":"20px"},
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.del($event)))
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}